export let UserStatus = /*#__PURE__*/ function (UserStatus) {
    UserStatus[UserStatus["Available"] = 0] = "Available";
    UserStatus[UserStatus["Unavailable"] = 1] = "Unavailable";
    UserStatus[UserStatus["Away"] = 2] = "Away";
    UserStatus[UserStatus["Dnd"] = 3] = "Dnd";
    UserStatus[UserStatus["Invisible"] = 4] = "Invisible";
    UserStatus[UserStatus["Eager"] = 5] = "Eager";
    UserStatus[UserStatus["Unknown"] = 255] = "Unknown";
    return UserStatus;
}({});
